module.exports = __webpack_public_path__ + "static/img/gxzs.418c098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soft/gxzs.jpg
// module id = /ob4
// module chunks = 13